import { IMaintenanceEvent, TUnplannedMaintenanceEvent } from '@/pages/Calendar/calendar.types'
import { IUser } from '@/pages/Users/users.types'
import { useMemo } from 'react'

const useReportWidgetsCtrl = (
  events: {
    planned: IMaintenanceEvent[]
    unplanned: TUnplannedMaintenanceEvent[]
  },
  users?: IUser[]
) => {
  const eventCountByType = useMemo(() => {
    const countByType = {
      OVERDUE_MAINTENANCE: 0,
      COMPLETED_MAINTENANCE: 0,
    }

    for (let e of events.planned) {
      if (countByType[e.type] != null) countByType[e.type] += 1
    }

    return {
      overdue: countByType.OVERDUE_MAINTENANCE,
      completed: countByType.COMPLETED_MAINTENANCE + events.unplanned.length,
    }
  }, [events])

  const bestEmploye = useMemo(() => {
    if (!users || users.length === 0) return null
    const respUserIds = events.planned
      .filter((e) => e.type === 'COMPLETED_MAINTENANCE')
      .map((e) => e.metadata.responsibleUsers)
      .flat()
    const userIds = [...respUserIds, ...events.unplanned.map((e) => e.createdBy.id)]
    const usersMap = new Map()
    for (let id of userIds) {
      usersMap.set(id, (usersMap.get(id) ?? 0) + 1)
    }
    let maxValue = [null, 0]
    for (const [key, value] of usersMap) {
      if (value > maxValue[1]) maxValue = [key, value]
    }

    if (maxValue[0] == null) return null
    return users.find((u) => u.id === maxValue[0])
  }, [events, users])

  return {
    overdueCountByType: eventCountByType.overdue,
    completedCountByType: eventCountByType.completed,
    bestEmploye,
  }
}

export default useReportWidgetsCtrl
